import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";
import { ImageLink } from "../constants";

const AddProjectPlan = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [tabData, setTabData] = useState([]);
  const [projectData, setProjectData] = useState([]);

  const [data, setData] = useState({
    projectId: editData?.projectId._id || "",
    title: editData?.title || "",
    planTabId: editData?.planTabId?._id || "",
    position: editData?.position || "",
    desktopImg: editData?.desktopImg || "",
  });

  const [errors, setErrors] = useState({
    projectId: "",
    title: "",
    planTabId: "",
    position: "",
    desktopImg: "",
  });

  const handleChange = (e) => {
    const { name, files, value } = e.target;
    if (name === "desktopImg") {
      setData({ ...data, [name]: files.length > 0 ? files[0] : null });
    } else {
      setData({ ...data, [name]: value });
    }
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasErrors = false;

    // Validate email
    if (!data.projectId.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "Project is required",
      }));
      hasErrors = true;
    }
    if (!data.planTabId.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "Plan Tab is required",
      }));
      hasErrors = true;
    }
    if (!data.position.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        position: "Position is required",
      }));
      hasErrors = true;
    }
    if (!data.desktopImg) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        desktopImg: "img is required",
      }));
      hasErrors = true;
    }
    if (hasErrors) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append("projectId", data.projectId);
      formData.append("title", data.title);
      formData.append("planTabId", data.planTabId);
      formData.append("position", data.position);
      if (data.desktopImg instanceof File) {
        formData.append("desktopImg", data.desktopImg);
      }

      const response = await axiosInstance.post(
        `project/createProjectPlan`,
        formData
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/plan");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("projectId", data.projectId);
      formData.append("title", data.title);
      formData.append("planTabId", data.planTabId);
      formData.append("position", data.position);
      if (data.desktopImg instanceof File) {
        formData.append("desktopImg", data.desktopImg);
      }

      const response = await axiosInstance.put(
        `project/updateProjectPlan/${editData?._id}`,
        formData
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/plan");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(
        `project/getWithoutPaginationProject`
      );
      const { data } = response.data;
      setProjectData(data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  const fetchDataTab = async () => {
    try {
      const response = await axiosInstance.get(
        `planTab/getWithoutPaginationTab`
      );
      const { data } = response.data;
      setTabData(data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  useEffect(() => {
    fetchData();
    fetchDataTab();
  }, []);

  const isImage = (file) => {
    return file && (file?.type?.startsWith('image/') || (typeof file === 'string' && /\.(jpg|jpeg|png|gif)$/.test(file)));
  };

  // Function to check if the file is a PDF
  const isPDF = (file) => {
    return file && (file?.type === 'application/pdf' || (typeof file === 'string' && /\.pdf$/.test(file)));
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="page-title">Add Project Plan</h3>
        </div>
        <div className="row grid-margin stretch-card">
          <div className="col-md-8  ">
            <div className="card">
              <div className="card-body">
                <form
                  className="pt-3"
                  onSubmit={editData?._id ? handleUpdate : handleSubmit}
                >
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername1"
                      className="col-sm-3 col-form-label"
                    >
                      Project
                    </label>
                    <div className="col-sm-9">
                      <select
                        className="form-control form-control-lg"
                        id="exampleFormControlSelect1"
                        name="projectId"
                        value={data.projectId}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          -- Please Select Project --
                        </option>
                        {projectData.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                      {errors.projectId && (
                        <p className="text-danger">{errors.projectId}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Document Title
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="title"
                        name="title"
                        placeholder="Enter title"
                        value={data.title}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername1"
                      className="col-sm-3 col-form-label"
                    >
                      Document Type
                    </label>
                    <div className="col-sm-9">
                      <select
                        className="form-control form-control-lg"
                        id="planTabId"
                        name="planTabId"
                        value={data.planTabId}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          -- Please Select --
                        </option>
                        {tabData.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                      {errors.galleryTabId && (
                        <p className="text-danger">{errors.galleryTabId}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Position
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="position"
                        name="position"
                        placeholder="Enter position"
                        value={data.position}
                        onChange={handleChange}
                      />
                      {errors.position && (
                        <p className="text-danger">{errors.position}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      File
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="file"
                        className="form-control form-control-sm"
                        id="desktopImg"
                        name="desktopImg"
                        placeholder="Enter plan img"
                        // value={data.desktopImg}
                        onChange={handleChange}
                      />
                      {errors.desktopImg && (
                        <p className="text-danger">{errors.desktopImg}</p>
                      )}
                    </div>
                  </div>

                  <div className="text-center mt-4">
                    <Link to="/plan">
                      <button className="btn btn-secondary mr-2">Back </button>
                    </Link>
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-4 stretch-card">
            <div className="card">
              {data.desktopImg && isImage(data.desktopImg) && (
                <div className="w-100 h-80 text-center mb-4">
                  <p className="mt-3">File Preview</p>
                  <br />
                  {data.desktopImg instanceof File ? (
                    <img
                      src={URL.createObjectURL(data.desktopImg)}
                      alt="Preview"
                      className="w-75"
                    />
                  ) : (
                    <img
                      src={ImageLink(data.desktopImg)}
                      alt="Preview"
                      className="w-75"
                    />
                  )}
                </div>
              )}
              <br />
              {data.desktopImg && isPDF(data.desktopImg) && (
                <div className="w-100 h-75 text-center mb-4">
                  <p className="mt-3">Pdf Preview</p>
                  <br />
                  {data.desktopImg instanceof File ? (
                    <Link to={URL.createObjectURL(data.desktopImg)} target="_blank">
                      <img src="images/icon/pdf.png" alt="pdf" className="ms-3 me-3" width={60} />
                    </Link>
                  ) : (
                    <Link to={ImageLink(data.desktopImg)} target="_blank">
                      <img src="images/icon/pdf.png" alt="pdf" className="ms-3 me-3" width={60} />
                    </Link>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProjectPlan;
